import { Alert, Box, constants, Text } from '@redbubble/design-system';
import { FormattedMessage } from '@redbubble/next/intl';
import { SearchResultsPageProps } from '../../types';
import styles from './VolumeDiscountBanner.module.scss';

export interface VolumeDiscountBannerProps {
  volumeDiscountThresholds: SearchResultsPageProps['volumeDiscountThresholds'];
}

export const VolumeDiscountBanner = ({
  volumeDiscountThresholds,
}: VolumeDiscountBannerProps) => {
  if (!volumeDiscountThresholds) return null;

  return (
    <Box marginBottom="m" data-testid="volume-discount-banner">
      <Alert intent={constants.INFORMATION} label={false}>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="center"
          flexWrap="wrap"
          justifyContent="center"
          className={styles.bannerContainer}
        >
          {volumeDiscountThresholds.map(({ quantity, percentOff }) => (
            <Text type="body" key={`volume-discount-${quantity}`}>
              <strong>
                <FormattedMessage
                  defaultMessage="Buy any {quantity} and get {percentOff}% off."
                  values={{ quantity, percentOff }}
                />
              </strong>
            </Text>
          ))}
        </Box>
      </Alert>
    </Box>
  );
};
